import React from 'react';
import { trackEvent } from '../../services/analytics';
import './DiscordCta.css';

/* Same invite as the footer card. Hardcoded rather than served by the backend:
   the whole point of this banner is that it works when nothing else does. */
const INVITE_URL = 'https://discord.gg/cCs7HrECdT';

const TXT = {
    title: {
        fr: 'Un bug ? Une idée ?',
        en: 'Found a bug? Got an idea?',
        de: 'Ein Bug? Eine Idee?',
        es: '¿Un bug? ¿Una idea?',
        pt: 'Um bug? Uma ideia?',
    },
    text: {
        fr: 'Rejoins le Discord dofgen pour remonter les bugs, proposer des idées et suivre les mises à jour.',
        en: 'Join the dofgen Discord to report bugs, suggest ideas and follow updates.',
        de: 'Komm auf den dofgen-Discord, um Bugs zu melden, Ideen vorzuschlagen und Updates zu verfolgen.',
        es: 'Únete al Discord de dofgen para reportar bugs, proponer ideas y seguir las actualizaciones.',
        pt: 'Entre no Discord do dofgen para reportar bugs, sugerir ideias e acompanhar as atualizações.',
    },
    join: {
        fr: 'Rejoindre le Discord',
        en: 'Join the Discord',
        de: 'Discord beitreten',
        es: 'Unirse al Discord',
        pt: 'Entrar no Discord',
    },
};

function t(dict, lang) {
    return dict[lang] || dict.en;
}

/**
 * Join-the-Discord banner for the home community section and the community page.
 *
 * Deliberately static. It carries no member or presence count: the numbers cost
 * a round trip and a backend proxy (Discord sends no CORS headers on the invite
 * endpoint), and they say nothing the copy doesn't already say better.
 *
 * `src` distinguishes the two placements in the analytics event.
 */
export function DiscordCta({ lang = 'fr', src }) {
    return (
        <a
            className="discord-cta"
            href={INVITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('discord_join', src ? { src } : undefined)}
        >
            <span className="discord-cta-logo" aria-hidden="true" />

            <span className="discord-cta-body">
                <span className="discord-cta-title">{t(TXT.title, lang)}</span>
                <span className="discord-cta-text">{t(TXT.text, lang)}</span>
            </span>

            {/* A real `primary alt`, like the actions row below it — the global
                rules are element-qualified (`button.primary.alt`), so only an
                actual button gets them. tabIndex -1 keeps the anchor a single
                tab stop. */}
            <button type="button" className="primary alt" tabIndex={-1}>
                {t(TXT.join, lang)}
            </button>
        </a>
    );
}
